import { IBrandResource } from "../../brands";
import { EntityTypes } from "../../EntityTypes";
import { IHydraResource, ITimestampable } from "../../types";

export interface IBadgeResource extends IHydraResource, ITimestampable {
    "@type": EntityTypes.BADGE;
    name: string;
    template: string;
    brand?: IBrandResource | string | null;
}

export const isBadgeResource = (resource: IHydraResource): resource is IBadgeResource => {
    return resource["@type"] === EntityTypes.BADGE;
};
